import { FlattenedGroupFolder } from 'owa-groups-services/lib/groups-rest-apis/schema/GroupFolder';
import { getContextMenuGroupsFolders } from 'owa-group-left-nav-folders-store';
import { getSelectedGroupId } from 'owa-group-utils';
import MoveToFolderType from '../store/schema/MoveToFolderType';

export const DEFAULT_GROUP_FOLDER_MOVETO_DEPTH = 2;

/**
 * converts FlattenedGroupsFolder to MoveToFolder
 * @param groupFolder the group folder
 * @returns the group folder wrapped in MoveToFolderType interface
 */
function convertToMoveToFolder(groupFolder: FlattenedGroupFolder): MoveToFolderType {
    return {
        folderId: groupFolder.Id,
        displayName: groupFolder.DisplayName.trim(),
        parentFolderId: groupFolder.ParentFolderId,
        parentFolderDisplayName: groupFolder.ParentFolderDisplayName,
        depth: groupFolder.Depth,
        mailboxInfo: null,
    };
}

/**
 * @returns Returns all the folders for the selected group wrapped in MoveToFolderType interface
 */
export function getAllMoveToFoldersForSelectedGroup(): MoveToFolderType[] {
    const groupFolders: FlattenedGroupFolder[] = getContextMenuGroupsFolders(getSelectedGroupId());
    const allMoveToFolders: MoveToFolderType[] = [];

    groupFolders.forEach(element => {
        const folder = convertToMoveToFolder(element);
        allMoveToFolders.push(folder);
    });

    return allMoveToFolders;
}
